var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 65.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1967d2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fbbc05;\n      }\n\n      .cls-3 {\n        fill: #34a853;\n      }\n\n      .cls-4 {\n        fill: #4285f4;\n      }\n\n      .cls-5 {\n        fill: #ea4335;\n      }\n\n      .cls-6 {\n        fill: #188038;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36,21.1L24.7,1.1c.4-.4.8-.6,1.2-.8-3.3,1.1-4.9,4.9-4.9,4.9L.3,41.7c-.3,1.1-.4,2.2-.3,3.1h22.6s13.4-23.7,13.4-23.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,21.1l13.4,23.7h22.6c0-.9,0-1.9-.3-3.1L51,5.1s-1.5-3.8-4.9-4.9c.4.2.9.4,1.2.8l-11.3,20h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36,21.1L47.3,1.1c-.4-.4-.8-.6-1.2-.8-.5-.2-1-.3-1.6-.3h-17c-.6,0-1.1.1-1.6.3-.4.2-.9.4-1.2.8l11.3,20Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.6,44.7l-11.2,19.8s-.4-.2-.9-.6c1.6,1.2,3.1,1.5,3.1,1.5h44c2.4,0,2.9-.9,2.9-.9h0l-11.2-19.8h-26.8.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.6,44.7H0c.1,2.7,1.3,4.3,1.3,4.3l.8,1.5h0c0,0,1.8,3.3,1.8,3.3l4.1,7.2c.1.3.3.6.4.8,0,0,.1.2.2.3.5.7,1.1,1.3,1.7,1.7.5.4.9.6.9.6h.2c0,0,11.2-19.7,11.2-19.7h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.4,44.7h22.6c0,2.7-1.3,4.3-1.3,4.3l-.8,1.5h0c0,0-1.8,3.3-1.8,3.3l-4.1,7.2c0,.3-.3.6-.4.8,0,0,0,.2-.2.3h0c-.5.7-1.1,1.3-1.7,1.7-.5.4-.9.6-.9.6h-.3c0,0-11.2-19.7-11.2-19.7h.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.fb2d9e9752203220710e6300f36dbb2b.svg";
export { ForwardRef as ReactComponent };